import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import ColorSquare from './color-square';
import TextSquare from './text-square';
import { ThumbUpAltOutlined } from '@material-ui/icons';
import { RESULT_TITLE, ERROR_NOT_COMPLETED, RETRY_MESSAGE } from '../../../libraries/texts';
import { dateFormatUTC, getFormatRut, getNumber } from '../../../libraries/formatters';
import {
  DATE_TIME_FRONT_FORMAT,
  decisionTrans,
  stateTrans,
  INSURANCE_WITH_PLAN
} from '../../../libraries/constants';
import Reasons from './reasons';
import { resultsContainer as styles } from '../styles';

const ResultState = props => {
  const { classes, data } = props;

  const { createdAt } = data;
  let { response } = data;
  if (!response) {
    response = {
      decision: '',
      state: ''
    };
  }

  const decision = decisionTrans(response.decision);
  const state = stateTrans(response.state);

  const getRange = () => {
    if (
      !response.patient ||
      !response.patient.insurance ||
      response.patient.insurance.name !== INSURANCE_WITH_PLAN
    ) {
      return '';
    }

    return response.patient.range ? `Tramo ${response.patient.range}` : '';
  };

  return (
    <React.Fragment>
      <Card className={classes.card}>
        <CardHeader
          title={RESULT_TITLE}
          className={classNames(classes.cardTitle, classes.titlePdl0)}
        />
        <CardContent className={classes.cardContent}>
          <div className={classes.flexSpaceAround}>
            <ColorSquare
              title="Decisión"
              className={classNames(classes.doubleSquare, {
                [classes.grayBck]: !response.decision,
                'no-decision': !response.decision || decision.state === 'pedient',
                [classes.orangeBck]: decision.state === 'pedient'
              })}
              subtitle={response.decision && decision ? decision.name : 'Sin Decisión'}
              icon={response.decision && decision ? <ThumbUpAltOutlined /> : ''}
              subsubtitle={response.decision && decision ? '' : <span> {RETRY_MESSAGE} </span>}
            />

            <ColorSquare
              className={classNames({
                [classes.whiteBck]: !response.patient || !response.patient.insurance,
                [classes.grayBck]: response.patient && response.patient.insurance
              })}
              title={response.patient && response.patient.insurance ? 'Previsión' : ''}
              subtitle={
                response.patient && response.patient.insurance
                  ? response.patient.insurance.name
                  : ''
              }
              subsubtitle={getRange()}
            />
          </div>

          <div className={classes.flexSpaceAround}>
            <TextSquare
              title="RUT Suscriptor"
              value={
                response.subscriber && response.subscriber.rut
                  ? getFormatRut(response.subscriber.rut).toUpperCase()
                  : ''
              }
              type="string"
            />
            <TextSquare
              title="Nombre Suscriptor"
              value={
                response.subscriber && response.subscriber.fullName
                  ? response.subscriber.fullName.toUpperCase()
                  : ''
              }
            />
            <TextSquare
              title="Dirección Suscriptor"
              value={
                !response.subscriber || !response.subscriber.address
                  ? ''
                  : `${response.subscriber.address.address.toUpperCase()} ${
                      response.subscriber.address.number
                    }, ${response.subscriber.address.commune.toUpperCase()}`
              }
              type="date"
            />
          </div>
          <Divider />
          <div className={classes.flexSpaceAround}>
            <TextSquare
              title="RUT Aval"
              value={
                response.endorser && response.endorser.rut
                  ? getFormatRut(response.endorser.rut).toUpperCase()
                  : ''
              }
              type="string"
            />
            <TextSquare
              title="Nombre Aval"
              value={
                response.endorser && response.endorser.fullName
                  ? response.endorser.fullName.toUpperCase()
                  : ''
              }
            />
            <TextSquare
              title="Dirección Aval"
              value={
                response.endorser &&
                response.endorser.address &&
                response.endorser.address.address &&
                response.endorser.address.commune
                  ? `${response.endorser.address.address.toUpperCase()} ${
                      response.endorser.address.number
                    }, ${response.endorser.address.commune.toUpperCase()}`
                  : ''
              }
              type="date"
            />
          </div>
          <Divider />
          <div className={classes.flexSpaceAround}>
            <TextSquare
              title="Monto presupuesto"
              value={response.budget ? `$${getNumber(response.budget.toString())}` : '$0'}
              className={classNames(classes.mountResult)}
              type="numeric"
            />
            <TextSquare
              title="Estimado monto beneficencia"
              value={response.benefit ? `$${getNumber(response.benefit.toString())}` : '$0'}
              className={classNames(classes.mountResult)}
              type="numeric"
            />
            <TextSquare
              title="Estimado cuotas"
              value={response.fees ? `${getNumber(response.fees.toString())}` : '0'}
              className={classNames(classes.mountResult, classes.midSixWidth)}
              type="numeric"
            />
            <TextSquare
              title="Monto cuota"
              value={response.feeAmount ? `$${getNumber(response.feeAmount.toString())}` : '$0'}
              className={classNames(classes.mountResult, classes.midSixWidth)}
              type="numeric"
            />
          </div>
          <React.Fragment />
        </CardContent>
      </Card>
      <Reasons reasons={response.reasons} state={state} />
      <Card className={classes.card}>
        <div className={classes.flexSpaceAround}>
          <TextSquare title="ID Solicitud" value={response.requestId} type="string" />
          <TextSquare
            title="Fecha/Hora Creación"
            value={dateFormatUTC(DATE_TIME_FRONT_FORMAT)(createdAt)}
            type="date"
          />
          <TextSquare
            title="Estado"
            value={
              state && state.name ? state.name.toUpperCase() : ERROR_NOT_COMPLETED.toUpperCase()
            }
            className={state.state === 'pedient' ? 'orangeBck' : ''}
          />
        </div>
      </Card>
    </React.Fragment>
  );
};

ResultState.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ResultState);
